import React from "react";

export const Accessories = () => {
  return <div>Accessories</div>;
};
